import { createSlotRecipe } from './runtime.js';

const tableFooterConfig = {"name":"tableFooter","className":"table-footer","slots":["root","content","paginationArea","trailingArea","totalCount","pageSizeSelect"]}

export const tableFooter = /* @__PURE__ */ createSlotRecipe(tableFooterConfig)